import script from "./Storie-item.vue?vue&type=script&setup=true&name=src%2Fcomponents%2FstoriesList.vue&lang=js"
export * from "./Storie-item.vue?vue&type=script&setup=true&name=src%2Fcomponents%2FstoriesList.vue&lang=js"

import "./Storie-item.vue?vue&type=style&index=0&id=99d4c270&lang=css"

const __exports__ = script;

export default __exports__